<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Barrington">

<svelte:fragment slot="blurb">
<InfoSection src="pics/barrington.jpg" alt="Barrington">
<p>Barrington is one of the most picturesque villages in the area with houses dotted along 30 acres of village green.</p>
<p><a href="http://www.barringtoncambs.com/" target="new">{@html Icon("external-link","small")} Barrington website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="Toddler_Park" Title="The Toddler Playground" src="pics/barry-little-kid-1.jpg" alt="The under 5s playground in Barrington" >
<p>The toddler playground features a fenced off area with soft sand on the floor, a tiny fort with a slide, and some springy animals.
It is for under 5s only but I think it would struggle to hold the attention for anyone 2 or above. It does have a free car park next to it however
so it is often our landing point in the village.</p>
</InfoSection>

<InfoSection id="Big_Kid_Park" Title="The Big Kid Playground" src="pics/barry-big-kid-1.jpg" alt="The big kid playground in Barrington">
<p>The big kid playground has a large array of play equipment, a basketball / football area, and what looks to be an agility section for dogs.</p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="foodanddrink">
<InfoSection id="the_royal_oak" Title="The Royal Oak"  src="pics/royal-oak.jpg" alt="The Royal Oak pub in Barrington">
<p>A 16th century thatched pub that offers food and drink.
 It is always very busy, especially on a sunny day. The building is very fun to traverse with low beams between the bar and the bathroom.
 The food is nice and outside tables offer great views of the village.</p>
</InfoSection>
</svelte:fragment>

</InfoPage>
